// extracted by mini-css-extract-plugin
export var divider = "_36-0";
export var dividerText = "_36-1";